import {Text} from '@dropbox/dig-components/typography';
import {atoms, Stack, withShade} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {StacksLine} from '@dropbox/dig-icons/assets';
import {DcdOwnershipService} from 'client';
import {Link} from 'components/DSYS/Link';
import {Title} from 'components/DSYS/Title';
import {getComponentsAndServicesServiceRoute} from 'constant';
import {t} from 'i18next';

export const OwnershipServicesCard = ({
  componentId,
  services,
  onClick,
}: {
  componentId: number;
  services: DcdOwnershipService[];
  onClick?: () => void;
}) => (
  <Stack
    gap="8"
    className={atoms({
      paddingX: '20',
      paddingY: '16',
      borderColor: 'Border Subtle',
      borderWidth: '1',
      borderStyle: 'Solid',
      borderRadius: 'Medium',
    })}
  >
    <Title size="small" withAccessoryStart={<UIIcon src={StacksLine} />}>
      {t('ownership_services')}
    </Title>
    {services.length ? (
      <Stack>
        {services.map((service) => (
          <Link
            key={service.id}
            to={getComponentsAndServicesServiceRoute(componentId, service.id)}
            aria-label={service.name}
            monochromatic
            hasNoUnderline
            onClick={onClick}
            {...withShade({
              className: atoms({display: 'block', padding: '8', borderRadius: 'Medium'}),
            })}
          >
            <Stack gap="2">
              <Text variant="label" size="medium" isBold tagName="span">
                {service.name}
              </Text>
              {service.description ? (
                <Text variant="paragraph" size="small" color="subtle" tagName="div">
                  {service.description}
                </Text>
              ) : null}
            </Stack>
          </Link>
        ))}
      </Stack>
    ) : (
      <Text variant="paragraph" size="large" tagName="p" color="faint">
        {t('ownership_no_services')}
      </Text>
    )}
  </Stack>
);
